module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-MediumItalic.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-MediumItalic.woff2
// module id = 80
// module chunks = 8